import { MapPin, TrainFront, Landmark, GraduationCap, ShoppingBag, Trees, ExternalLink } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";
import { CONTACT } from "./data";

const PLACES = [
  { icon: Landmark, name: "Palacio Municipal de Ecatepec", time: "A unos pasos" },
  { icon: TrainFront, name: "Mexibús Líneas 2 y 4", time: "Conexión directa" },
  { icon: Trees, name: "Parque Ehécatl", time: "A unos pasos" },
  { icon: GraduationCap, name: "Universidad Ecatepec", time: "Zona educativa" },
  { icon: ShoppingBag, name: "Patio Ecatepec · Av. Revolución", time: "Comercio cercano" },
];

export default function Location() {
  return (
    <section id="ubicacion" data-testid="location-section" className="relative py-24 sm:py-32 lg:py-40 bg-[#1c242f]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
        <div>
          <SectionHead
            eyebrow="Ubicación"
            title={<>En el centro<br />de <span className="gold-text italic">todo</span></>}
          />
          <Reveal delay={0.15}>
            <p className="mt-7 text-[#a8ac9b] leading-relaxed text-base sm:text-lg max-w-lg">
              Vivir en EHÉCATL es tener cerca cultura, educación, naturaleza y actividades para
              toda la familia. Ubicación céntrica en San Cristóbal Centro con conectividad
              eficiente hacia todo el Valle de México.
            </p>
          </Reveal>
          <div className="mt-10 space-y-1">
            {PLACES.map((p, i) => (
              <Reveal key={p.name} delay={0.1 + i * 0.06} y={16}>
                <div className="flex items-center gap-5 py-4 border-b border-white/5 group">
                  <p.icon size={19} className="text-[#bfa360] shrink-0" />
                  <p className="flex-1 text-[#f4f2ea] text-sm sm:text-base">{p.name}</p>
                  <p className="mono text-[10px] sm:text-[11px] uppercase tracking-[0.18em] text-[#a8ac9b] text-right">{p.time}</p>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.3}>
            <a
              data-testid="location-maps-cta"
              href={CONTACT.mapsUrl}
              target="_blank"
              rel="noreferrer"
              className="mt-9 inline-flex items-center gap-3 text-sm text-[#ddc68c] link-line"
            >
              <MapPin size={16} />
              {CONTACT.address}
              <ExternalLink size={13} />
            </a>
          </Reveal>
        </div>

        <Reveal delay={0.1} y={40}>
          <div className="img-frame relative rounded-2xl overflow-hidden border border-white/10">
            <img src="/images/mapa.webp" alt="Mapa de ubicación Condominio EHÉCATL" loading="lazy" decoding="async" className="w-full h-auto" />
            <div className="absolute inset-0 ring-1 ring-inset ring-white/10 rounded-2xl pointer-events-none" />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
